/** Ad scripts and origins, shared by their loaders and the shell's connection hints. */
export const LAUNCHPAD_WRAPPER_URL =
  'https://launchpad-wrapper.privacymanager.io/528606c5-a8ba-42f7-be55-93209da0477d/launchpad-liveramp.js'
export const LAUNCHPAD_BUNDLE_URL =
  'https://launchpad.privacymanager.io/latest/launchpad.bundle.js'
export const GPT_ORIGIN = 'https://securepubads.g.doubleclick.net'
export const FUNDING_CHOICES_ORIGIN =
  'https://fundingchoicesmessages.google.com'
export const TABOOLA_ORIGIN = 'https://cdn.taboola.com'
export const OUTBRAIN_ORIGIN = 'https://widgets.outbrain.com'
export const OUTBRAIN_SCRIPT_URL = `${OUTBRAIN_ORIGIN}/outbrain.js`

export function ayManagerUrl(entityId: string): string {
  return `https://${entityId}.ay.delivery/manager/${entityId}`
}

export function taboolaLoaderUrl(publisherName: string): string {
  return `${TABOOLA_ORIGIN}/libtrc/${publisherName}/loader.js`
}
